export const publicationsTranslations = {
  // Publications tab translations
  loading: {
    en: 'Loading...',
    fi: 'Ladataan...'
  },
  noPublications: {
    en: 'No publication',
    fi: 'Ei julkaisuja'
  },
  noPublicationsFound: {
    en: 'No publications found.',
    fi: 'Julkaisuja ei löydy.'
  },
  publications: {
    en: 'Publications',
    fi: 'Julkaisut'
  },
  addPublication: {
    en: 'Add Publication',
    fi: 'Lisää julkaisu'
  },
  editPublication: {
    en: 'Edit Publication',
    fi: 'Muokkaa julkaisua'
  },
  publicationName: {
    en: 'Publication Name',
    fi: 'Julkaisun nimi'
  },
  noPublicationName: {
    en: 'Unnamed Publication',
    fi: 'Nimetön julkaisu'
  },
  year: {
    en: 'Year',
    fi: 'Vuosi'
  },
  yearPlaceholder: {
    en: 'e.g., 2023',
    fi: 'esim. 2023'
  },
  selectYear: {
    en: 'Select Year',
    fi: 'Valitse vuosi'
  },
  description: {
    en: 'Description',
    fi: 'Kuvaus'
  },
  descriptionPlaceholder: {
    en: 'Enter publication description...',
    fi: 'Syötä julkaisun kuvaus...'
  },
  publicationDescriptionPlaceholder: {
    en: 'Enter details about your publication...',
    fi: 'Syötä tietoja julkaisustasi...'
  },
  edit: {
    en: 'Edit',
    fi: 'Muokkaa'
  },
  delete: {
    en: 'Delete',
    fi: 'Poista'
  },
  save: {
    en: 'Save',
    fi: 'Tallenna'
  },
  update: {
    en: 'Update',
    fi: 'Päivitä'
  },
  cancel: {
    en: 'Cancel',
    fi: 'Peruuta'
  },
  success: {
    en: 'Success',
    fi: 'Onnistui'
  },
  publicationAddedSuccess: {
    en: 'Publication added successfully',
    fi: 'Julkaisu lisätty onnistuneesti'
  },
  publicationUpdatedSuccess: {
    en: 'Publication updated successfully',
    fi: 'Julkaisu päivitetty onnistuneesti'
  },
  publicationDeletedSuccess: {
    en: 'Publication deleted successfully',
    fi: 'Julkaisu poistettu onnistuneesti'
  },
  confirmDeletePublication: {
    en: 'Are you sure you want to delete this publication?',
    fi: 'Haluatko varmasti poistaa tämän julkaisun?'
  },
  error: {
    en: 'Error',
    fi: 'Virhe'
  },
  required: {
    en: 'Required',
    fi: 'Pakollinen'
  },
  cannotEditPublicationWithUndefinedId: {
    en: 'Cannot edit publication with undefined ID',
    fi: 'Julkaisua ei voi muokata, tunniste puuttuu'
  }
};